import styled from "@emotion/styled";

const Container = styled.div`
  height: 32px;
  width: 32px;
  flex-shrink: 0;
  margin-left: 10px;
`;

const Image = styled.img`
  border-radius: 50%;
  height: 100%;
  width: 100%;
`;

type Props = {
  alt: string;
  src: string;
};

export const SubforestAvatar = ({ alt, src, ...rootProps }: Props) => (
  <Container {...rootProps}>
    <Image alt={alt} src={src} />
  </Container>
);
